module.exports = "https://bin.bnbstatic.com/_next/static/images/Academy-bd1699b689f9004bafd080036d16a701.png";